import { CommissionFilters } from "@/models/commission-report.model";

export const startOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
export const endOfMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);

export const INITIAL_FILTERS: CommissionFilters = {
  startDate: startOfMonth.toISOString(),
  endDate: endOfMonth.toISOString(),
  type: "b2c",
  vendedorName: "",
};

export interface Column {
  key: string;
  label: string;
  isNumeric?: boolean;
}

export const B2C_COLUMNS: Column[] = [
  { key: "nomeConsultor", label: "Nome Consultor" },
  { key: "usuario", label: "Usuário (acesso login)" },
  { key: "emailConsultor", label: "E-mail Consultor" },
  { key: "cpfConsultor", label: "CPF Consultor" },
  { key: "dataOperacao", label: "Data da Operação" },
  { key: "numeroProposta", label: "Número da Proposta" },
  { key: "corbanMaster", label: "Corban Master" },
  { key: "nomeCliente", label: "Nome do Cliente" },
  { key: "cpfCliente", label: "CPF do Cliente" },
  { key: "telefoneCliente", label: "Telefone do Cliente" },
  { key: "valorBloqueado", label: "Valor Bloqueado", isNumeric: true },
  { key: "valorLiberado", label: "Valor Liberado", isNumeric: true },
  { key: "anosAntecipados", label: "Anos Antecipados" },
  { key: "nivel", label: "Nível" },
  { key: "bancarizadora", label: "Bancarizadora" },
  { key: "contratoZipdin", label: "Número de Contrato na Zipdin" },
  { key: "status", label: "Status" },
  { key: "dataDesembolso", label: "Data do Desembolso" },
  { key: "observacao", label: "Observação" },
  { key: "percentualComissao", label: "% Comissão Cobrada", isNumeric: true },
  { key: "comissaoTotal", label: "Comissão Total", isNumeric: true },
];

export const B2B_COLUMNS_COMMON: Column[] = [
  { key: "nomeConsultor", label: "Nome Consultor" },
  { key: "usuario", label: "Usuário (acesso login)" },
  { key: "emailConsultor", label: "E-mail Consultor" },
  { key: "cpfConsultor", label: "CPF Consultor" },
  { key: "dataOperacao", label: "Data da Operação" },
  { key: "numeroProposta", label: "Número da Proposta" },
  { key: "corbanMaster", label: "Corban Master" },
  { key: "corbanId", label: "Código do Corban" },
  { key: "promoter", label: "Promotora" },
  { key: "commercialManager", label: "Gerente Comercial" },
  { key: "nomeCliente", label: "Nome do Cliente" },
  { key: "cpfCliente", label: "CPF do Cliente" },
  { key: "telefoneCliente", label: "Telefone do Cliente" },
  { key: "valorBloqueado", label: "Valor Bloqueado", isNumeric: true },
  { key: "valorLiberado", label: "Valor Liberado", isNumeric: true },
  { key: "anosAntecipados", label: "Anos Antecipados" },
  { key: "nivel", label: "Nível" },
  { key: "bancarizadora", label: "Bancarizadora" },
  { key: "contratoZipdin", label: "Número de Contrato na Zipdin" },
  { key: "status", label: "Status" },
  { key: "dataDesembolso", label: "Data do Desembolso" },
  { key: "observacao", label: "Observação" },
  { key: "percentualComissao", label: "% Comissão Cobrada", isNumeric: true },
];

export const B2B_COLUMNS_BASE: Column[] = [
  ...B2B_COLUMNS_COMMON,
  { key: "comissaoTotal", label: "Comissão Total", isNumeric: true },
];

export const B2B_BLUEPAY_COLUMNS: Column[] = [
  ...B2B_COLUMNS_COMMON,
  { key: "comissaoBruta", label: "Comissão Bruta", isNumeric: true },
  { key: "comissaoLiquida", label: "Comissão Líquida", isNumeric: true },
];

export const B2B_KAMINO_COLUMNS: Column[] = [
  { key: "comissaoBruta", label: "Comissão Bruta", isNumeric: true },
  { key: "comissaoLiquida", label: "Comissão Líquida", isNumeric: true },
  { key: "csll", label: "CSLL", isNumeric: true },
  { key: "irrf", label: "IRRF", isNumeric: true },
  { key: "cofins", label: "COFINS", isNumeric: true },
  { key: "pis", label: "PIS", isNumeric: true },
];

export const KAM_COLUMNS: Column[] = [...B2B_COLUMNS_BASE];

export const B2B_COLUMNS_TAIL: Column[] = [];

export const DATE_KEYS = new Set(["dataOperacao", "dataDesembolso", "dataPagamento"]);
export const CURRENCY_KEYS = new Set([
  "valorBloqueado", "valorLiberado", "comissaoTotal",
  "comissaoBruta", "comissaoLiquida", "csll", "irrf", "cofins", "pis",
]);
export const DOCUMENT_KEYS = new Set(["cpfConsultor", "cpfCliente"]);
export const PHONE_KEYS = new Set(["telefoneCliente"]);
